import { useSelectedButtonColor } from 'src/editor/shared/hooks/use-theme-color/use-selected-button-color'
import { ButtonHoverEntityInterface } from 'src/shared/schemas/button-hover.schema'
import { WebsiteButtonTypes } from 'src/shared/types/website-settings-types'

export interface UseCalculateButtonHoverProps
  extends ButtonHoverEntityInterface {
  buttonType: WebsiteButtonTypes
}

export const useCalculateButtonHover = ({
  hover,
  mobileHover,
  buttonType,
}: UseCalculateButtonHoverProps) => {
  const { hoveredButtonBackgroundColor } = useSelectedButtonColor(buttonType)

  return {
    calculatedHover: {
      desktop: {
        ...hover,
        backgroundColor: hover?.backgroundColor || hoveredButtonBackgroundColor,
      },
      mobile: {
        ...mobileHover,
        backgroundColor:
          mobileHover?.backgroundColor ||
          hover?.backgroundColor ||
          hoveredButtonBackgroundColor,
      },
    },
  }
}
